import gql from 'graphql-tag';

export const GetApplicationBidsByIdQuery = gql`
         query GetApplicationBidsByIdQuery($applicationId: String) {
           applicationBids(applicationId: $applicationId) {
             id
             name
             amount
             selected
             isFirstBid
             howSubmitted
             reason
             _Ebb_ApplicationId
             _Ebb_OwnerId
             _Ebb_ContractorId
             _Ebb_ApprovalTaskItemId
             payload
             payloadName
           }
         }
       `;
